import { GET_BOLETAS_REPORT_BY_FILTER } from '@/graphql/reports/boleta'

// models
import { ReportBoletas, FilterReportBoletas } from '@/models/reports/ReportBoletas'

// apollo
import { apolloClient } from '@/apollo'

class ReportBoletaService {
  async getReportBoletas (input: FilterReportBoletas): Promise<ReportBoletas> {
    const result = await apolloClient.query({
        query: GET_BOLETAS_REPORT_BY_FILTER,
        variables: {
          input
        }
    })
    return result.data.getReportBoletas
  }
}

export default new ReportBoletaService()
